module.exports = __webpack_public_path__ + "img/news.875beb03.svg";